module.exports = "/lucky-balls/img/flower.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/flower.png
// module id = 1059
// module chunks = 0